/* unplugin-vue-components disabled */import script from "./MapWithMarkers.vue?vue&type=script&setup=true&lang=js"
export * from "./MapWithMarkers.vue?vue&type=script&setup=true&lang=js"

import "./MapWithMarkers.vue?vue&type=style&index=0&id=977edb16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-977edb16"]])

export default __exports__